import { NA } from '../../pages/arc/constants/constant-strings';
import { LabelSettingProps } from '../models/epi-model';

const notApplicableRate = 0;
const defaultExtensionPrefix = 'ext.';

export function isNotApplicableRate(toNumber: number) : boolean {
	return toNumber === notApplicableRate;
}

export function getCurrencyFormat(value: number | string, labelSettings?: LabelSettingProps, showNA: boolean = false) {
	const toNumber = parseFloat(value?.toString());
	const isNotANumber = Number.isNaN(toNumber);
	const isNotApplicableRateResult = isNotApplicableRate(toNumber);

	if (isNotANumber || (showNA && isNotApplicableRateResult)) return labelSettings?.naLabel || NA;

	return `$${toNumber?.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
}

export function getPhoneFormat(countryCode: string, areaCode: string, number: string, extension: string = null, extensionPrefix: string = defaultExtensionPrefix) {
	if (!number) return '';	

	return `${countryCode ? `+${countryCode} ` : ''}${areaCode ? `${areaCode}-` : ''}${number}${extension ? ` ${extensionPrefix} ${extension}` : ''}`;
}

export function getYearsFormat(years: number) : string {    
	if (!years) return null;

    return Number(years).toFixed(4);
}

export function enumFromValue<T extends Record<string, string>>(val: string, _enum: T){	
    const enumName = (Object.keys(_enum) as Array<keyof T>).find(k => _enum[k] === val);

    if (!enumName) return null;

    return _enum[enumName];
}